import { Component, OnInit} from '@angular/core'
import { Constants } from 'app/shared/constant/constants';
import { constants } from 'buffer';
import { RatesService } from '../services/rates.service';
import { GTMDataLayerService } from 'app/shared/services/gtmDataLayer.service';
import { ConstantsKey } from 'app/shared/constant/constants-keys';

@Component({
  selector: 'rates',
  templateUrl: './rates.component.html',
})
export class RatesComponent implements OnInit {
  
  public rateList : any;
  public showLoader : boolean = false;
  public custMobile = ""; 

  constructor(public rateService:RatesService,
      public gtmPushService: GTMDataLayerService) {}

  ngOnInit() {
    this.getRateListAll(Constants.productsEnum[2]);

    let consumerData = localStorage.getItem(ConstantsKey.CONSUMER_DATA);
    if(consumerData) {
      consumerData = JSON.parse(consumerData);      
      this.custMobile = consumerData["mobile"];
    }    

    let evtObj = {
      "event": "rates-page",
      "rate_page_visit": 'Y',
      "mobile": this.custMobile != "" ? "91"+this.custMobile : ""
    };
    this.gtmPushService.dataLayerPushData(evtObj);
  }

  getRateListAll(productType){
    this.showLoader = true;
    this.rateService.getRatesList(productType).subscribe(res=>{
      this.showLoader = false;
      this.rateList = [];
      this.rateList = res.body[0].rates;
      console.log(this.rateList);
    },error=>{
      this.showLoader = false;
    })
  }
}
